<template>
    <u-text-field-filled-rounded v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-filled-rounded>
</template>

<script>
import UTextFieldFilledRounded from "@/components/publish/styles/forms/u-text-field-filled-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextFieldFilledRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
